<template>
  <sidebar-row>
    <v-col cols="auto" class="px-0 pb-0">
      <v-list class="py-0 rounded-lg elevation-4" dense>
        <v-list-item class="graph-generation-params-element">
          <v-list-item-content style="padding: 0.8rem 0">
            <v-list-item-title class="text-body-2">
              <v-row no-gutters class="flex-nowrap" align="center">
                <v-col cols="auto" style="max-width: 50%">
                  <v-icon class="pr-3" large :color="documentIcon === 'file-pdf-box' ? 'red' : ''">
                    mdi-{{ `${documentIcon}` }}
                  </v-icon>
                </v-col>
                <v-col cols="7">
                  <v-row no-gutters class="flex-col">
                    <v-col cols="12" class="text-left">
                      <v-tooltip bottom color="font">
                        <template #activator="{ on }">
                          <div id="name" class="text-body-2 text-truncate" style="max-width:100%" v-on="on">
                            {{ attributes.name }}
                          </div>
                        </template>
                        <div style="word-break: break-all;">
                          {{ attributes.name }}
                        </div>
                      </v-tooltip>
                    </v-col>
                    <v-col cols="12">
                      <v-tooltip bottom color="font" max-width="300">
                        <template #activator="{ on }">
                          <div v-on="on">
                            <italic-subheader
                              id="filename"
                              :straight-text="attributes.filename"
                              class="text-truncate"
                              style="display: inherit !important; max-width:100%"
                            >
                            </italic-subheader>
                          </div>
                        </template>
                        <div style="word-break: break-all;">
                          {{ attributes.filename }}
                        </div>
                      </v-tooltip>
                    </v-col>
                  </v-row>
                </v-col>
                <v-spacer></v-spacer>
                <v-col cols="auto">
                  <v-row no-gutters align="center">
                    <v-col v-if="attributes.is_photo" cols="auto">
                      <v-tooltip bottom color="font" max-width="300">
                        <template #activator="{ on }">
                          <v-btn v-on="on" icon @click="imagePreviewVisible = true">
                            <v-icon>
                              mdi-magnify
                            </v-icon>
                          </v-btn>
                        </template>
                        <div style="word-break: break-all;">
                          {{ $i18n.t('button.filePreview') }}
                        </div>
                      </v-tooltip>
                    </v-col>
                    <v-col cols="auto">
                      <v-tooltip bottom color="font" max-width="300">
                        <template #activator="{ on }">
                          <v-btn v-on="on" icon @click="downloadAttachment($route.params.fid)">
                            <v-icon>
                              mdi-download
                            </v-icon>
                          </v-btn>
                        </template>
                        <div style="word-break: break-all;">
                          {{ $i18n.t('button.fileDownload') }}
                        </div>
                      </v-tooltip>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-col>
    <image-lightbox :items="photo" :visible.sync="imagePreviewVisible" enableZoom></image-lightbox>
  </sidebar-row>
</template>

<script>
import SidebarRow from '@/components/SidebarRow';
import ItalicSubheader from '@/components/ItalicSubheader';
import { call, get } from 'vuex-pathify';

export default {
  name: 'WidgetDocumentInformations',
  components: {
    SidebarRow,
    ItalicSubheader,
    ImageLightbox: () => import('@/components/ImageLightbox'),
  },
  props: {
    attributes: {
      type: Object,
      default: null,
    },
  },
  data: () => ({
    imagePreviewVisible: false,
  }),
  computed: {
    token: get('authentication/token'),
    documentIcon() {
      let documentType = 'image';
      if (this.attributes) {
        if (!this.attributes.is_photo) {
          this.attributes.filename.split('.').at(-1) === 'pdf'
            ? (documentType = 'file-pdf-box')
            : (documentType = 'file');
        }
      }
      return documentType;
    },
    photo() {
      return [
        `${process.env.VUE_APP_API_URL}/attachments/${this.$route.params.fid}/file?as_attachment=false&token=${this.token}`,
      ];
    },
  },
  methods: {
    downloadAttachment: call('relations/downloadAttachment'),
  },
};
</script>

<style lang="scss" scoped>
.graph-generation-params-element {
  @include border(bottom);
  text-align: left;
}
.graph-generation-params-list {
  border-radius: 4px;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25), 0px -1px 0px rgba(0, 0, 0, 0.15) !important;
}
::v-deep .v-input--selection-controls {
  padding: 0 !important;
}

::v-deep {
  .carousel_image {
    .v-responsive__content {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}
</style>
